const inquiry = {
  requestProduct: 'Produkt anfragen',
  from: 'von',
  packSize: 'Packungsgröße',
  check: 'Preis und Verfügbarkeit des Artikels können Sie telefonisch oder über unser Formular in Ihrer <b>{pharmacyName}</b> erfragen.',
  inquiryForm: 'Anfrage-Formular',
  promise: '<strong>Unser Versprechen:</strong> Wir nutzen die Telefonnummer nur für eventuelle Rückfragen der Apotheke zu Ihren Vorbestellungen. Außerdem werden Sie per SMS und E-Mail über den Status Ihrer Bestellung informiert.',
  fillMandatory: '* Bitte füllen Sie die Pflichtfelder aus',
  sendInquiry: 'Anfrage senden',
  submitError: 'Ihre Anfrage konnte leider nicht gesendet werden.',
  submitSuccess: 'Ihre Anfrage wurde erfolgreich an die Apotheke gesendet.',
  policy: {
    termsOfUse: 'Nutzungsbedingungen',
    privacyPolicy: 'Datenschutzbestimmungen',
    1: 'Die',
    2: 'und',
    3: 'habe ich zur Kenntnis genommen und bin mit ihrer Geltung einverstanden.*',
  },
}

export default inquiry
